module.exports = __webpack_public_path__ + "static/img/msp_back.afa5d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/msp_back.png
// module id = CBiT
// module chunks = 0